import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Popper,
  Paper,
  ClickAwayListener,
  Box,
  MenuItem,
} from "@material-ui/core";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  startOfMonth,
  startOfYear,
  subMonths,
} from "date-fns";
import { getStartOfDay, getEndOfDay } from "../../utils/utils";
import ExportIcon from "../../assets/images/export2.svg";

const ExportDropdown = ({ onExport, isExporting,disabled=false }) => {
  const [open, setOpen] = useState(false);
  const [showCustomPicker, setShowCustomPicker] = useState(false);
  const [customDates, setCustomDates] = useState([null, null]);
  const buttonRef = useRef();

  const handleToggle = () => {
    setOpen((prev) => !prev);
    setShowCustomPicker(false);
  };

  const handleClose = () => {
    setOpen(false);
    setShowCustomPicker(false);
  };

  const handleExportRange = (key) => {
    const now = new Date();
    let from;
    const to = getEndOfDay(now);

    switch (key) {
      case "currentMonth":
        from = startOfMonth(now);
        break;
      case "lastSixMonths":
        from = startOfMonth(subMonths(now, 5));
        break;
      case "currentYear":
        from = startOfYear(now);
        break;
      case "custom":
        setShowCustomPicker(true);
        return;
      default:
        return;
    }

    handleClose();
    onExport(getStartOfDay(from), to);
  };

  const handleCustomExport = (dates) => {
    setCustomDates(dates);
    if (Array.isArray(dates) && dates.length === 2) {
      const [start, end] = dates;
      if (start && end) {
        onExport(getStartOfDay(start), getEndOfDay(end));
        setShowCustomPicker(false);
        handleClose();
      }
    }
  };

  return (
    <Box position="relative" display="inline-block">
      <Button
        ref={buttonRef}
        variant="outlined"
        onClick={handleToggle}
        disabled={isExporting || disabled}
        startIcon={
          <img
            src={ExportIcon}
            alt="Export"
            style={{ width: 20, height: 15 }}
          />
        }
      >
        Export
      </Button>

      <Popper
        open={open || showCustomPicker}
        anchorEl={buttonRef.current}
        placement="bottom-start"
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper elevation={4}>
            {showCustomPicker ? (
              <Box p={2}>
                <DatePicker
                  selectsRange
                  maxDate={new Date()}
                  inline
                  startDate={customDates[0]}
                  endDate={customDates[1]}
                  onChange={handleCustomExport}
                />
              </Box>
            ) : (
              <>
                <MenuItem onClick={() => handleExportRange("currentMonth")}>
                  Current Month
                </MenuItem>
                <MenuItem onClick={() => handleExportRange("lastSixMonths")}>
                  Last Six Months
                </MenuItem>
                <MenuItem onClick={() => handleExportRange("currentYear")}>
                  Current Year
                </MenuItem>
                <MenuItem onClick={() => handleExportRange("custom")}>
                  Custom Range
                </MenuItem>
              </>
            )}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};

ExportDropdown.propTypes = {
  onExport: PropTypes.func.isRequired,
  isExporting: PropTypes.bool,
  disabled:PropTypes.bool,
};

export default ExportDropdown;
